import { EditTags } from "../index";

export default function EditTagsFunc(currDishId: string, currDishTags: string) {
  return EditTags(currDishId, currDishTags)
}
